import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';



class SeferTescilBilgisiDetails extends Component {
    render() {
        return (
            <BootstrapTable className="detailsGrid" data={this.props.data}>
                <TableHeaderColumn dataField='TescilKayitId' isKey={true} hidden>ID</TableHeaderColumn>
                <TableHeaderColumn dataField='TescilNumarasi' width="250px">Tescil Numarası</TableHeaderColumn>
                <TableHeaderColumn dataField='TescilIslemTarihi'>Tescil Tarihi</TableHeaderColumn>
            </BootstrapTable>
        );
    }
}

export default SeferTescilBilgisiDetails;


// WEBPACK FOOTER //
// ./src/components/containers/SeferTescilBilgisiDetails.js